import { z } from 'zod/mini'

import { amount, eventValue, itemObject } from './fields'
import { gtmMetadataShape } from './gtm-metadata'
import { itemShape } from './item'
import { nonEmptyString } from './non-empty-string'

/** Pushed by `trackAddToFavorite`. */
export const addToWishlistSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('add_to_wishlist'),
  ecommerce: z.strictObject({
    currency: nonEmptyString(),
    value: eventValue(),
    items: z
      .array(
        itemObject({
          ...itemShape,
          item_is_trade_in_eligible: z.boolean(),
          item_is_favorited: z.literal(true),
          item_days_since_favorited: z.number().check(z.gte(0)),
          item_price_when_favorited: amount(),
          item_favorited_location: nonEmptyString(),
        }),
      )
      .check(z.minLength(1), z.maxLength(1)),
  }),
})
